import React from "react";
import { Panel } from '@appkit4/react-components/panel';

const HelpChatWindow: React.FC = () => {
  const panelStyle = {
    padding: '20px',
  };

  const footer = (
    <div>
      If you have any feedback and suggestions for new modules or how to improve the tool, please contact any of the below:
      <ul>
        <li>Thomas.Sheat@PwC.com</li>
        <li>Philip.z.Davis@PwC.com</li>
        <li>[PensionsAI@Email]</li>
      </ul>
    </div>
  );

  return (
    <div className="ap-simple-panel-container">
      <Panel className="helpcontainer"
        bordered
        footer={footer}
        style={panelStyle}
      >
        <h2>Best Practices:</h2>
        <ul>
          <li>Be as clear and specific as possible when asking questions.</li>
          <li>For complex queries, feel free to break them into smaller parts.</li>
        </ul><br></br>
        <h2>Frequently Asked Questions:</h2>
        <ul>
          <li>[TBC]</li>
        </ul><br></br>
        <h2>Contact / Support details:</h2>
        <p>
          If you encounter any problems with the tool, please email our team email address below. Please be clear in the problem that you have encountered and ideally include screenshots.
        </p><br></br>
        <ul>
          <li>[PensionsAI@Email]</li>
        </ul><br></br>
      </Panel></div>
  );
}

export default HelpChatWindow